import { fetchInvoicesAction } from './actions';

export const fetchInvoices = () => (dispatch) => dispatch(fetchInvoicesAction());
